import styled from "@emotion/styled";

export default function Update() {
  return (
    <RootWrapperUpdate>
      <Updated>View Details: Redirect to the Admin Referrals Two</Updated>
    </RootWrapperUpdate>
  );
}

const RootWrapperUpdate = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  min-height: 100vh;
  background: rgb(255, 234, 44);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 6px;
`;

const Updated = styled.span`
  color: rgb(255, 44, 29);
  text-overflow: ellipsis;
  font-size: 20px;
  font-family: Consolas, sans-serif;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
`;
